<div class='flex' [style]='wrapStyles'>
  @for (item of items; track item) {
    <div class='loading-item blink' [style]='styles'></div>
  }
</div>
